import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import AuthContext from '../../api/AuthProvider';

export const PrivateRoute = ({ children, ...rest }) => {
    let { user } = useContext(AuthContext);

    if (!user) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export const PublicRoute = ({ children, ...rest }) => {
    let { user } = useContext(AuthContext);

    if (user) {
        return <Navigate to="/" replace />;
    }
    return children;
};
